module.exports = __webpack_public_path__ + "img/arrow-white-up.4e91f43f.svg";